import { render, staticRenderFns } from "./newGamePoint.vue?vue&type=template&id=da2a4646&"
import script from "./newGamePoint.vue?vue&type=script&lang=js&"
export * from "./newGamePoint.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports